import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();  // Hook to access the current location (path)

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the location changes
  }, [location]);  // Runs every time the location changes (route changes)

  return null;
};

export default ScrollToTop;
